<template>
  <el-card :body-style="{ height: '100%' }">
    <div class="flex items-center h-32px mb-10px">
      <p class="pl-10px border-l-3px text-18px border-color-primary">
        {{ $t('人员信息') }}
      </p>
    </div>
    <el-form :model="formData" disabled label-width="150px">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('姓名')}`">
            <el-input
              size="small"
              :placeholder="`${$t('请输入')}`"
              v-model="formData.personnelName"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('部门')}`">
            <el-input size="small" v-model="formData.unitName" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('违章总积分')}`">
            <el-input size="small" v-model="formData.totalScore" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="searchList">
      <el-tab-pane label="违章/处罚信息" name="first">
        <div class="flex">
          <div class="mr-10px">处罚次数：{{ formData.punishCount }}</div>
          <div class="mr-10px">违章扣分：{{ formData.penaltyScore }}</div>
          <div class="mr-10px">处罚金额(元)：{{ formData.penaltyAmount }}</div>
          <div class="mr-10px">教育培训(h)：{{ formData.trainHour }}</div>
        </div>
        <el-table stripe :data="tableData" highlight-current-row row-key="id" class="mt-20px">
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column :label="`${$t('违章描述')}`" prop="description" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章类型')}`" prop="typeName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章级别')}`" prop="levelName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章时间')}`" prop="violationTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.violationTime | showText('time') }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('处罚情况')}`" prop="TradeName" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row | showText('des', 1) }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('操作')}`" width="200" fixed="right">
            <template #default="{ row }">
              <el-button size="mini" @click="toDetail(row)">{{ $t('查看') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="反违章/奖励信息" name="second">
        <div class="flex">
          <div class="mr-10px">奖励次数：{{ formData.rewardCount }}</div>
          <div class="mr-10px">奖励积分：{{ formData.rewardScore }}</div>
          <div class="mr-10px">奖励金额(元)：{{ formData.rewardAmount }}</div>
        </div>
        <el-table
          stripe
          :data="tableData"
          :highlight-current-row="true"
          :row-key="(record) => record.Id"
          class="mt-20px"
          height="400px"
        >
          <el-table-column :label="`${$t('序号')}`" type="index" width="60"></el-table-column>
          <el-table-column :label="`${$t('违章描述')}`" prop="description" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章类型')}`" prop="typeName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章级别')}`" prop="levelName" show-overflow-tooltip />
          <el-table-column :label="`${$t('违章时间')}`" prop="violationTime" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.violationTime | showText('time') }}
            </template>
          </el-table-column>
          <el-table-column :label="`${$t('奖励情况')}`" prop="TradeName" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row | showText('des', 2) }}
            </template></el-table-column
          >
          <el-table-column :label="`${$t('操作')}`" width="120" fixed="right">
            <template #default="{ row }">
              <el-button size="mini" @click="toDetail(row)">{{ $t('查看') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog
      :close-on-click-modal="false"
      :title="`${$t('违章信息详情')}`"
      :visible.sync="showViolation"
      class="large-dialog"
      width="90%"
      v-dialogDrag
    >
      <div class="flex items-center h-32px mb-10px justify-between">
        <p class="pl-10px border-l-3px text-18px border-color-primary">
          {{ $t('违章信息') }}
        </p>
        <el-button @click="openFlow">查看流程</el-button>
      </div>
      <BasicInfoCom :propsKey="operateFormat.base" operateType="action" ref="BasicInfoCom" />
      <MainCom :operateFormat="operateFormat" ref="MainInfoCom" :propsStatus="6" />
    </el-dialog>
    <ApprovalFlowDialog
      :visible.sync="approvalFlowDialog"
      v-if="approvalFlowDialog"
      :id="flowTaskId"
      @cancel="approvalFlowDialog = false"
    >
    </ApprovalFlowDialog>
  </el-card>
</template>

<script>
import { ViolationRecordApi } from '@wiz-api/personnel-safety-management'
import { sourceList } from '@/components/safety/WizSafetyPage/violation/enums'
import dayjs from 'dayjs'

const violationRecordApi = new ViolationRecordApi()
const BasicInfoCom = () => {
  return import('@/components/safety/WizSafetyPage/violation/BasicInfoCom')
}
const MainCom = () => {
  return import('@/components/safety/WizSafetyPage/violation/MainCom')
}
const ApprovalFlowDialog = () => {
  return import('@/components/safety/ApprovalFlow/ApprovalFlowDialog')
}

export default {
  name: 'personViolationRecord',
  components: {
    BasicInfoCom,
    MainCom,
    ApprovalFlowDialog,
  },
  computed: {},
  props: ['userId', 'unitId'],
  filters: {
    showText: (val, type, tab) => {
      let result = ''
      if (type === 'time' && val) {
        result = dayjs(val).format('YYYY-MM-DD HH:mm:ss')
      }
      if (type === 'des') {
        result = `${tab === 1 ? '违章扣分' : '奖励积分'}${val.score}分,${
          tab === 1 ? '违章' : '奖励'
        }金额${val.amount}元`
      }
      return result
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      activeName: 'first',
      formData: {},
      showViolation: false,
      operateFormat: {},
      approvalFlowDialog: false,
      flowTaskId: '',
    }
  },
  created() {
    this.getViolationInfo()
    this.searchList()
  },
  methods: {
    async getViolationInfo() {
      const [err, res] = await violationRecordApi.violationArchives({
        maxResultCount: 1,
        skipCount: 0,
        sorting: 'CreationTime DESC',
        personnelId: this.userId,
      })
      if (!err && res.items.length) {
        this.formData = res.items[0]
      }
    },
    async searchList() {
      this.loading = true
      const [err, res] = await violationRecordApi.violationArchivesDetials({
        userId: this.userId,
        unitId: this.unitId,
        detialsType: this.activeName === 'first' ? 1 : 2,
      })
      this.loading = false
      if (!err) {
        this.tableData = res
      }
    },
    openFlow() {
      if (typeof this.flowTaskId === 'string' && _.includes(this.flowTaskId, '-')) {
        window.wiz.OpenWorkFlowDesignByFlowId(this.flowTaskId)
      } else {
        this.approvalFlowDialog = true
      }
    },
    async toDetail(row) {
      const [err, res] = await violationRecordApi.getRecord({ id: row.recordId })
      if (!err) {
        this.showViolation = true
        this.operateFormat = sourceList.vioExamineInfo
        this.flowTaskId = res.violationRecord.flowTaskId
        this.$nextTick(() => {
          this.$refs.BasicInfoCom?.detailShow(res.violationRecord)
          this.$refs.MainInfoCom?.detailShow(res.violationHandling)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
